import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { AppInfoService } from '@shared/services/common/app-info.service';
import { MailhtmlModel } from '@shared/models/mailhtml-model';
import { MailKanbanModel } from '@shared/models/mailKanbanHeader-model';

@Injectable({
    providedIn: 'root'
})
export class MailService {

    constructor(public appInfo: AppInfoService, private http: HttpClient) {

    }

    getHtmlBody(_guid: string): Observable<any> {
        let params = new HttpParams().set("guid", _guid);

        return this.http.get<any>(this.appInfo.appUrl + "api/mail/gethtmlbody", { params: params });
    }

    getSmtp(): Observable<any> {
        return this.http.get<any>(this.appInfo.appUrl + "api/mail/getsmtp", this.appInfo.httpOptions);
    }

    postHtmlBody(model:any): Observable<MailhtmlModel> {
        return this.http.post<MailhtmlModel>(this.appInfo.appUrl + "api/mail/posthtmlbody", JSON.stringify(model), this.appInfo.httpOptions);
    }

    postMail(model: any): Observable<MailKanbanModel> {
        var test = {
                Id: 1,
                Userid :1,
                Guid :'TEST',
                Htmlbody:'DENEME'
            }
        return this.http.post<MailKanbanModel>(this.appInfo.appUrl + "api/mail/postkanbanmail", JSON.stringify(model), this.appInfo.httpOptions);
  }

  createEmailBody = (
    user: any,
    mailContent: string,
    kanbanName: string,
    columnName: string,
    taskSubject: string,
    taskDetails: string,
    date: any,
    creatorName: string
  ): string => {

    return `
    <div style="font-family: 'Segoe UI', Arial, sans-serif; background-color: #f9fafb; padding: 20px; color: #1f2937;">
      <div style="max-width: 600px; margin: 0 auto; background-color: #ffffff; border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
        
        <div style="background-color: #4f46e5; height: 6px;"></div>

        <div style="padding: 24px;">
          <h2 style="margin: 0 0 16px 0; font-size: 18px; color: #111827; font-weight: 700;">Görev Bildirimi</h2>
          <p style="margin: 0 0 24px 0; font-size: 15px; line-height: 1.6; color: #4b5563;">${mailContent}</p>
          
          <div style="background-color: #f3f4f6; border-radius: 8px; padding: 16px;">
            <table style="width: 100%; border-collapse: collapse;">
              <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280; width: 100px;"">Atayan</td>
                <td style="padding-bottom: 12px; font-size: 14px; font-weight: 600;">${creatorName}</td>
              </tr>
              <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280; width: 100px;">İşlem Yapan</td>
                <td style="padding-bottom: 12px; font-size: 14px; font-weight: 600;">${user.name}</td>
              </tr>
              <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280; width: 100px;">Pano</td>
                <td style="padding-bottom: 12px; font-size: 14px; font-weight: 600;">${kanbanName}</td>
              </tr>
              <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280;">Aşama (Kolon)</td>
                <td style="padding-bottom: 12px;">
                  <span style="background-color: #dbeafe; color: #1e40af; padding: 2px 8px; border-radius: 4px; font-size: 12px; font-weight: 500;">
                    ${columnName}
                  </span>
                </td>
              </tr>
              <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280;">Başlık</td>
                <td style="padding-bottom: 12px; font-size: 14px; font-weight: 600;">${taskSubject}</td>
              </tr>
              <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280; vertical-align: top;">Detay</td>
                <td style="padding-bottom: 12px; font-size: 14px; line-height: 1.4;">${taskDetails}</td>
              </tr>
               <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280;">Başlangıç</td>
                <td style="padding-bottom: 12px; font-size: 14px; color: #2AA63E; font-weight: 600;">${date.start}</td>
              </tr>
              <tr>
                <td style="padding-bottom: 12px; font-size: 13px; color: #6b7280;">Bitiş</td>
                <td style="padding-bottom: 12px; font-size: 14px; color: #dc2626; font-weight: 600;">${date.end}</td>
              </tr>
           
            </table>
          </div>
        </div>

        <div style="background-color: #f9fafb; padding: 12px 24px; border-top: 1px solid #e5e7eb; text-align: center;">
          <small style="color: #9ca3af; font-size: 11px;">Bu bir sistem mesajıdır, lütfen yanıtlamayınız.</small>
        </div>
      </div>
    </div>
  `;
  };


}
